import AdminsForm from "../utils/AdminsForm";

export default class AdminsNew {

    constructor() {
        this.adminsForm = new AdminsForm();
        //this.bindEvents();
        //window.application.setOnDataChangeListener(this);
    }

    onDataChanged(data) {
    }

    onDestroy() {
        this.adminsForm.onDestroy();
    }
}